var map = {
	"./appointmentConsultations/EditOrNew.vue": [
		"4b0d",
		"chunk-2d0cba58"
	],
	"./books/EditOrNew.vue": [
		"567c",
		"chunk-2d0c8a63"
	],
	"./categories/EditOrNew.vue": [
		"2069",
		"chunk-2d0b1677"
	],
	"./chatConsultations/EditOrNew.vue": [
		"53eb",
		"chunk-2d0c84b1"
	],
	"./contact/EditOrNew.vue": [
		"62d2",
		"chunk-2d0cf500"
	],
	"./coupons/EditOrNew.vue": [
		"840c",
		"chunk-2d0ddf25"
	],
	"./diplomats/EditOrNew.vue": [
		"fef3",
		"chunk-2d238682"
	],
	"./emergencyConsultations/EditOrNew.vue": [
		"b798",
		"chunk-2d2102ea"
	],
	"./employees/EditOrNew.vue": [
		"5ccd",
		"chunk-2d0d38a5"
	],
	"./faqs/EditOrNew.vue": [
		"6b65",
		"chunk-2d0da3a1"
	],
	"./lecturers/EditOrNew.vue": [
		"adff",
		"chunk-2d213d19"
	],
	"./mediaSettings/EditOrNew.vue": [
		"c2f7",
		"chunk-2d2169f6"
	],
	"./meetingConventions/EditOrNew.vue": [
		"c730",
		"chunk-2d217687"
	],
	"./messages/EditOrNew.vue": [
		"098d",
		"chunk-2d0a4feb"
	],
	"./notifications/EditOrNew.vue": [
		"b7dd",
		"chunk-2d21084b"
	],
	"./offlineCourses/EditOrNew.vue": [
		"dd1b",
		"chunk-2d2293c7"
	],
	"./onlineCourses/EditOrNew.vue": [
		"8250",
		"chunk-2d0dd80b"
	],
	"./ourValues/EditOrNew.vue": [
		"cc86",
		"chunk-2d221c54"
	],
	"./pages/EditOrNew.vue": [
		"6ed4",
		"chunk-2d0db475"
	],
	"./reports/EditOrNew.vue": [
		"910b",
		"chunk-2d0e4840"
	],
	"./roles/EditOrNew.vue": [
		"39cd",
		"chunk-2d0bb23d"
	],
	"./services/EditOrNew.vue": [
		"2373",
		"chunk-2d0b21d3"
	],
	"./settings/EditOrNew.vue": [
		"208f",
		"chunk-2d0b16e2"
	],
	"./slider/EditOrNew.vue": [
		"b4ea",
		"chunk-2d20fd24"
	],
	"./splashes/EditOrNew.vue": [
		"e0f5",
		"chunk-2d224b30"
	],
	"./team/EditOrNew.vue": [
		"ffbc",
		"chunk-2d2389f7"
	],
	"./users/EditOrNew.vue": [
		"2d17",
		"chunk-2d0bd90e"
	],
	"./videoConsultations/EditOrNew.vue": [
		"1f04",
		"chunk-2d0b6c0f"
	],
	"./voiceConsultations/EditOrNew.vue": [
		"5b7a",
		"chunk-2d0d2f8d"
	],
	"./workFields/EditOrNew.vue": [
		"8397",
		"chunk-2d0ddc4f"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "86ca";
module.exports = webpackAsyncContext;